// Error messages for configuration
const ErrorMessages = {
  depotNotFound: {
    errors: [
      {
        field: 'depot_ids | depot_id',
        message: 'Unable to find the depots',
      },
    ],
  },
  documentNotFound: {
    errors: [
      {
        field: 'documents',
        message: 'Unable to find the documents',
      },
    ],
  },
  duplicateSlaType: {
    errors: [
      {
        field: 'sla_type',
        message: 'Duplicate Sla type',
      },
    ],
  },
  invalidSlaDuration: {
    errors: [
      {
        field: 'days, hours, mins',
        message: 'Sum of all the fields could not be zero',
      },
    ],
  },
  invalidAcceptanceSlaDuration: {
    errors: [
      {
        field: 'hours, mins',
        message: 'Acceptance Sla should be before arrival sla',
      },
    ],
  },
  duplicateMaterialHeader: {
    errors: [
      {
        field: 'required_fields, custom_fields, update_combination',
        message: 'Duplicate field present.',
      },
    ],
  },
  requiredMaterialHeaderMismatch: {
    errors: [
      {
        field: 'required_fields',
        message: 'Required Fields mismatch',
      },
    ],
  },
  notAllMaterialHeaderValid: {
    errors: [
      {
        field: 'required_fields | custom_fields | update_combination',
        message: 'Not all material headers are valid',
      },
    ],
  },
  invalidMaterialHeaderUpdateCombination: {
    errors: [
      {
        field: 'update_combination',
        message: 'Contains a invalid update combination.',
      },
    ],
  },
  duplicatNotificationType: {
    errors: [
      {
        field: 'notification_type',
        message: 'Duplicate Notification type',
      },
    ],
  },
  duplicatUnitType: {
    errors: [
      {
        field: 'unit_type',
        message: 'Duplicate Unit type',
      },
    ],
  },
  invalidUnitType: {
    errors: [
      {
        field: 'value',
        message: 'Value of unit type is invalid',
      },
    ],
  },
  invalidSlotDuration: {
    errors: [
      {
        field: 'start_time | end_time',
        message: 'slot Cannot have the same start and end time',
      },
    ],
  },
  invalidSlot: {
    errors: [
      {
        field: 'value',
        message: 'Value of unit type is invalid',
      },
    ],
  },
  clientLrNotFound: {
    errors: [
      {
        field: 'auto_generation_enabled',
        message: 'Client level code is empty.',
      },
    ],
  },
  invalidDepotLrFound: {
    errors: [
      {
        field: 'auto_generation_enabled',
        message: 'Cannot be applied to some depot.',
      },
    ],
  },
  updateOptimaSettings: {
    errors: [
      {
        field: 'optima settings',
        message: 'update optima settings first.',
      },
    ],
  },
};

module.exports = { ErrorMessages };
